import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/logo-white.svg'
import _imports_1 from '@/assets/img/github.svg'


const _withScopeId = n => (_pushScopeId("data-v-3b42e224"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "heading" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "NZGM",
    title: "NZGrapherModern",
    width: "148",
    height: "90"
  })
], -1))
const _hoisted_2 = { class: "content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "What is NZGM", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "NZGM"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("span", null, "NZGrapher Modern"),
  /*#__PURE__*/_createTextVNode(") is a graphing tool designed to out perform and improve upon "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://github.com/mathsnz/NZGrapher/",
    target: "_blank",
    rel: "noopener"
  }, "NZGrapher"),
  /*#__PURE__*/_createTextVNode(" using more modern technologies and taking a serverless aproach. ")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "features" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "material-icons" }, "dns"),
    /*#__PURE__*/_createElementVNode("h3", null, "Serverless Aproach"),
    /*#__PURE__*/_createElementVNode("p", null, " This application does not require a backend server to run so it can be installed and run completely offline. The only time a server is present in this app is for distributing the source files. ")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "material-icons" }, "cloud"),
    /*#__PURE__*/_createElementVNode("h3", null, "Mordern Techologies"),
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createElementVNode("b", null, "NZGM"),
      /*#__PURE__*/_createTextVNode(" is using modern techologies such as "),
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://v3.vuejs.org/",
        target: "_blank",
        rel: "noopener"
      }, "VueJS"),
      /*#__PURE__*/_createTextVNode(" and "),
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://www.typescriptlang.org/",
        target: "_blank",
        rel: "noopener"
      }, "TypeScript"),
      /*#__PURE__*/_createTextVNode(" these allow the app to be well put together and prevent errors while also encourages faster development times. ")
    ])
  ])
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" This project is created and maintained by "),
  /*#__PURE__*/_createElementVNode("b", null, "Jacob Read"),
  /*#__PURE__*/_createTextVNode(" (Jacobtread) you can view my github here. "),
  /*#__PURE__*/_createElementVNode("a", {
    class: "github-button",
    href: "https://github.com/jacobtread/",
    target: "_blank",
    rel: "noopener"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_1,
      alt: "GitHub Logo"
    }),
    /*#__PURE__*/_createTextVNode("GitHub")
  ]),
  /*#__PURE__*/_createTextVNode(" or at "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://github.com/jacobtread/",
    target: "_blank",
    rel: "noopener"
  }, "https://github.com/jacobtread/"),
  /*#__PURE__*/_createTextVNode(" and you can view the source code for this app at "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://github.com/jacobtread/NZGM",
    target: "_blank",
    rel: "noopener"
  }, "https://github.com/jacobtread/NZGM")
], -1))
const _hoisted_7 = { class: "checkbox" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkbox__mark" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkbox__text" }, "Dont show this dialog again.", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    open: _ctx.show,
    class: "about-dialog"
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _createElementVNode("button", {
          class: "start-button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hideAbout && _ctx.hideAbout(...args)))
        }, "Start Using"),
        _createElementVNode("label", _hoisted_7, [
          _hoisted_8,
          _withDirectives(_createElementVNode("input", {
            class: "checkbox__input",
            type: "checkbox",
            name: "",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.hideNext) = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.hideNext]
          ]),
          _hoisted_9
        ])
      ])
    ]),
    _: 1
  }, 8, ["open"]))
}